// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './vuex/store'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Mint, { Toast } from 'mint-ui'
import 'mint-ui/lib/style.css'
import './assets/css/my-swiper.css'
import './assets/css/my-mint.css'
import 'lib-flexible'
import './assets/css/iconfont/iconfont.css'
import 'vue-croppa/dist/vue-croppa.css'
import Croppa from 'vue-croppa'
import { initPushServices, handleRegistrationID } from './assets/js/pushServices'

Vue.use(Mint)
Vue.use(ElementUI)
Vue.use(Croppa)

Vue.config.productionTip = false
Vue.use(VueAwesomeSwiper)
Vue.use(require('vue-moment'))

const debug = process.env.NODE_ENV !== 'production'

const version = '2018122001' // 版本号
Vue.prototype.version = version

var exitApp = false

var intval = setInterval(function () {
  exitApp = false
}, 1000)

Vue.prototype.onBack = (e) => {
  if (window.location.hash === '#/indexOne' || window.location.hash === '#/checkOut') {
    e.preventDefault()
    if (exitApp) {
      clearInterval(intval)
      navigator.app.exitApp()
    } else {
      exitApp = true
      Toast({
        message: '再点击一次退出程序!',
        position: 'bottom',
        duration: 2500
      })
    }
  } else {
    window.history.back()
  }
}

var app =
  {
    initialize: function () {
      if (!debug) {
        document.addEventListener('deviceready', this.onDeviceReady.bind(this), false)
        document.addEventListener('backbutton', Vue.prototype.onBack, false)
        document.addEventListener('resume', this.onResume.bind(this), false)
        document.addEventListener('jpush.receiveRegistrationId', function (event) {
          // handleRegistrationID(event.registrationId)
          handleRegistrationID()
        }, false)
      } else {
        this.initVue()
      }
    },

    onDeviceReady: function () {
      initPushServices()
      handleRegistrationID()
      navigator.splashscreen.hide()
      this.initVue()
      // this.checkUpdate()
    },
    //  获取数据的成功回调和失败回调                                                                                                            
    getSuccess: function (obj) {
    },

    getError: function (error) {
      console.log(error)
    },

    onResume: function () {
      this.checkUpdate()
    },

    checkUpdate: function () {
      if (typeof (cordova) === 'undefined' || typeof (chcp) === 'undefined') {
        failure('当前环境不支持热更新!')
        return
      }

      chcp.isUpdateAvailableForInstallation(function (error, data) {
        if (error) {
          // 继续检查拉取更新版本
          chcp.fetchUpdate(app.fetchUpdateCallback)
        } else {
          if (data.readyToInstallVersion > data.currentVersion) {
            // 有更新且版本大于当前，则安装更新
            console.log('Need to install!')
            alert('Need to Update!\nNow version:' + data.currentVersion + '\nNew version:' + data.readyToInstallVersion)
            chcp.installUpdate(app.installationCallback)
          } else {
            // 无最新版本，继续检查拉取
            console.log('Try to get new version!')
            chcp.fetchUpdate(app.fetchUpdateCallback)
          }
        }
      })
    },

    fetchUpdateCallback: function (error, data) {

    },

    installationCallback: function (error) {

    },

    initVue: function () {
      let vm = new Vue({
        el: '#app',
        router,
        store,
        components: { App },
        template: '<App/>'
      })
      Vue.use({
        vm
      })
    }
  }

app.initialize()



// WEBPACK FOOTER //
// ./src/main.js